import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import SelectionBar from './SelectionBar';
import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Header/AbandonedBookingsHeader.module.scss';
import { AbandonedBookingsHeaderActions } from 'components/Bookings2/Abandoned/Header/Actions/AbandonedBookingsHeaderActions';
import { AbandonedBookingsAddButton } from 'components/Bookings2/Abandoned/Header/Actions/AddButton/AbandonedBookingsAddButton';
import { TextField2 } from 'components/UI';
import SearchComponentPopup from 'components/UI/SearchComponentPopup';
import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import { debounce } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const AbandonedBookingsHeader: React.FC = () => {
    const { query, setQuery, type, setType } = useAbandonedBookings();

    const { loading, metrics } = useSelector((state: RootState) => state.bookingAttempts);

    return (
        <div className={styles.root}>
            <div className={styles.row}>
                <h2 className={clsx(styles.title, styles.onlyMobile)}>
                    Abandoned Bookings
                    <SearchComponentPopup
                        title="Abandoned Bookings"
                        placeholder="Search by clients or pets"
                        className={styles.onlyMobile}
                        onSearch={debounce(setQuery, 250)}
                    />
                    <AbandonedBookingsAddButton className={styles.onlyMobile} />
                </h2>

                <TextField2
                    value={query ?? ''}
                    startIcon={<FontAwesomeIcon icon={faSearch} />}
                    placeholder="Search by clients or pets"
                    className={styles.search}
                    onChange={debounce(setQuery, 250)}
                />

                <AbandonedBookingsHeaderActions className={styles.onlyDesktop} />
            </div>

            <div className={styles.metricsRow}>
                <h2 className={clsx(styles.title, styles.onlyDesktop)}>Abandoned Bookings</h2>

                {metrics && (
                    <div className={styles.metrics}>
                        <MetricBox
                            isLoading={loading}
                            title="Total Abandoned"
                            value={metrics?.totalCount}
                        />
                        <MetricBox
                            isLoading={loading}
                            title="Converted"
                            value={metrics?.convertedCount}
                        />
                        <MetricBox
                            isLoading={loading}
                            title="Converted Value"
                            value={`$${metrics?.convertedValue.toFixed(2)}`}
                        />
                    </div>
                )}
            </div>

            <div className={styles.row}>
                <SelectionBar
                    options={[
                        { id: 'abandoned', name: 'Abandoned' },
                        { id: 'converted', name: 'Converted' }
                    ]}
                    selectedOptionId={type}
                    onSelect={setType}
                />

                <AbandonedBookingsHeaderActions className={styles.onlyMobile} />
            </div>
        </div>
    );
};
